<template>
<main>
    <!-- <div class="image-group">
      <div class="image">
        <img src="../assets/img/home/group2/photo1.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/home/group2/photo2.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/home/group2/photo3.png" alt="">
      </div>
    </div> -->
    
  <section id="angebot">
   <h2 class="sr-only">Mein Leistungen</h2>
    <div class="blue-box">
      <div class="flex-group">
          <!-- <ul class="no-bullet-list">
            <li class="leistungen-training"> -->
              <div class="text">
                <h3>Training von Pferd &amp; Reiter</h3>
                <ul>
                  <li>Reitunterricht</li>
                  <li>Beritt</li>
                  <li>Bodenarbeit, Körperarbeit, Körpersprache &amp; Kommunikation</li>
                  <li>Rehatraining, Aufbautraining</li>
                  <li>Sitzschulung und Körperwahrnehmung</li>
                  <li>Bewegungsanalyse von Pferd und Reiter</li>
                </ul>
              </div>
              <div>
                <img src="../assets/img/leistungen/reitunterricht.png" alt="">
              </div>
            </div>
      </div>

    <div class="red-box">
      <div class="flex-group">
          <div>
                <img src="../assets/img/leistungen/hufe.png" alt="">
              </div>
              <div class="text">
                <h3>Hufbearbeitung &amp; Fütterung</h3>
                <ul>
                  <li>Barhufbearbeitung</li>
                  <li>Klebebeschläge und Beratung zu alternativem Hufschutz</li>
                  <li>Beratung zu Haltung und Fütterung</li>
                  <li>Wechselwirkungen von Training und Hufgesundheit</li>
              </ul>
              </div>
             
            </div>
      </div>

      <div class="blue-box">
        <div class="flex-group">
         
              <div class="text">
               <h3>Kurse und Webinare</h3>
               <p>Kurse mit unterschiedlichsten Schwerpunkten zu Training und Gesundheit von Reiter und Pferd</p>
               <span class="btn-red">
                <router-link :to="{ path: '/termine' }" class="link">aktuelle Termine</router-link>
              </span>
              </div>
              <div>
                <img src="../assets/img/leistungen/kurs.png" alt="">
              </div>
            </div>
      </div>

      <div class="darkgreen-box">
        <div class="flex-group">
              <div>
                <img src="../assets/img/leistungen/neuro.png" alt="">
              </div>
              <div class="text">
               <h3>Neuro-Athletik Training für Reiter</h3>
               <p>Unter dem Motto "Besser Reiten mit Neuro-Athletik Training" biete ich unterschiedliche Formate und Schwerpunkt-Themen zur Verbesserung der Leistungsfähigkeit des Reiters an.</p>
                <span class="btn-red">
                  <router-link :to="{ path: '/neuro' }" class="link">Neuro-Athletik Training</router-link>
                </span>
              </div>
            </div>
      </div>
           

      <div class="grey-box">
        <div class="flex-group"> 
          <div class="text text-wide"> 
            <p>
                  Ich arbeite mit Pferden aller Rassen und Reitern aller Ausbildungsstufen. Mein Schwerpunkt liegt in der vielseitigen
                  Ausbildung von Reiter und Pferd.
            </p>
          </div>
        </div>
      </div>
    </section>

  </main>

</template>

<script>
export default {
  name: "Leistungen", //this is the name of the component
  
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
  metaInfo() {
      return { 
          title: "Leistungen und Angebote Pferdeverstand - Sabine D&ouml;br&ouml;ssy",
          meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Training und Gesundheit für Reiter und Pferd'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at'}

          ]
      }
  }
};

//TODO meta daten
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Leistungen.vue